import * as React from 'react';

/*
import { Form } from '../models/form';
import { FormComponent } from '../models/form-component';
import { FormComponentType } from '../models/enums';
import { ResponseError } from '../models/response-error';
import { LookupItem } from '../models/lookup-item';
import { CrudFunctions } from '../utilities/crud-functions';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form as DataGridForm,
    Toolbar,
    Paging,
    Item as ToolBarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Template } from 'devextreme-react/core/template';
import { Item } from 'devextreme-react/form';
import { Popup as DialogPopup } from 'devextreme-react/popup';

import {
    TextBox,
    NumberBox,
    CheckBox
} from 'devextreme-react';

import HelpDocumentSearch from './HelpDocumentSearch';

export interface Props {
    forms?: Form[];
    selectedForm?: Form;
    components?: FormComponent[];
    componentTypes?: FormComponentType[];
    selectedComponent?: FormComponent;
    formHelpDocumentsSearchDialogVisible?: boolean;
    dataLoaded?: boolean;
}
*/

export default function FormConfigurationForm() {

    return (
        <div>WIP</div>
    )
}

/*
                <div id="form-configuration-main">
                    <div className="lq-title-bar">
                        <div className="lq-main-title">Form Configuration</div>
                    </div>

                    <div>
                        <div>
                            <DataGrid
                                height="20em"
                                onSelectionChanged={this.formsTableSelectionChanged}
                                onRowValidating={this.onFormValidating}
                                onRowRemoving={this.onFormDeleting}
                                dataSource={this.state.forms ?
                                    this.state.forms : []}
                                showBorders={true}>

                                <LoadPanel enabled={true} />
                                <Selection mode={'single'} />
                                <HeaderFilter visible={true} />
                                <FilterRow visible={true} />
                                <Paging enabled={false} />
                                                                
                                <Column dataField={'name'} width={'40%'} allowEditing={false} />
                                <Column dataField={'description'} width={'60%'} />

                                <Column type="buttons" width={'6.5rem'}
                                    buttons={[
                                        {
                                            icon: 'help',
                                            hint: 'Help Documents',
                                            onClick: this.showFormHelpDocumentsSearchDialog
                                        },
                                        {
                                            name: 'edit'
                                        }
                                    ]} />

                                <Toolbar>
                                    <ToolBarItem location='before' template='formsToolbarTitleTemplate' />
                                </Toolbar>

                                <Template name="formsToolbarTitleTemplate" render={this.formsToolbarTitleTemplateRender} />

                                <Editing
                                    mode="popup"
                                    useIcons={true}
                                    allowAdding={false}
                                    allowDeleting={false}
                                    allowUpdating={true} >

                                    <Popup title="Forms" showTitle={true} width={700} height={380} />
                                    <DataGridForm>
                                        <LoadPanel enabled={true} />
                                        <Item dataField="name" colSpan={2} />
                                        <Item dataField="description" colSpan={2} />
                                        <Item dataField="helpLink" colSpan={2} />
                                    </DataGridForm>
                                </Editing>
                            </DataGrid>

                            <br />

                            <DataGrid
                                height="30em"
                                dataSource={this.state.components ?
                                    this.state.components : []}
                                onSelectionChanged={this.componentsTableSelectionChanged}
                                onRowValidating={this.onFormComponentValidating}
                                onRowRemoving={this.onFormComponentDeleting}
                                showBorders={true}>

                                <LoadPanel enabled={true} />
                                <Selection mode={'single'} />
                                <HeaderFilter visible={true} />
                                <FilterRow visible={true} />
                                <Paging enabled={false} />

                                <Column dataField={'name'} width={'30%'} allowEditing={false} />
                                <Column dataField={'description'} width={'45%'} />
                                <Column dataField={'componentType'} width={'25%'} allowEditing={false} />


                                <Toolbar>
                                    <ToolBarItem location='before' template='formComponentsToolbarTitleTemplate' />
                                </Toolbar>

                                <Template name="formComponentsToolbarTitleTemplate" render={this.formComponentsToolbarTitleTemplateRender} />

                                <Editing
                                    mode="popup"
                                    useIcons={true}
                                    allowAdding={false}
                                    allowDeleting={false}
                                    allowUpdating={true} >

                                    <Popup title="Form Components" showTitle={true} width={700} height={380} />
                                    <DataGridForm>

                                        <LoadPanel enabled={true} />
                                        <Item dataField="name" colSpan={2} />
                                        <Item dataField="description" colSpan={2} />
                                        <Item dataField="componentType" colSpan={2} />
                                    </DataGridForm>
                                </Editing>

                            </DataGrid>
                        </div>

                        <br />
                        <div>
                            <div className="lq-sub-title">Component</div>

                            <div className="form-grid-3">
                                <div className="form-unit">
                                    <label className="textbox-label">Name</label>
                                    <TextBox id="name" className="textbox"
                                        placeholder="name" value={this.state.selectedComponent ?
                                            this.state.selectedComponent.name : ''} />
                                </div>

                                <CheckBox id="nullable" text="Nullable" className="checkbox-label"
                                    value={this.state.selectedComponent ? this.state.selectedComponent.nullable : true} />

                            </div>

                            <div className="form-grid-3">
                                <div className="form-unit">
                                    <label className="textbox-label">Length</label>
                                    <NumberBox id="length" className="textbox"
                                        showClearButton={true}
                                        placeholder="length" value={this.state.selectedComponent ?
                                            this.state.selectedComponent.length : undefined} />
                                </div>

                                {this.state.selectedComponent &&
                                    this.state.selectedComponent.componentTypeEnum === FormComponentType.NumberBox ?
                                    <div>
                                        <div className="form-unit">
                                            <label className="textbox-label">Max</label>
                                            <NumberBox id="max" className="textbox"
                                                placeholder="max" value={this.state.selectedComponent ?
                                                    this.state.selectedComponent.max : undefined} />
                                        </div>
                                        <div className="form-unit">
                                            <label className="textbox-label">Min</label>
                                            <NumberBox id="min" className="textbox"
                                                placeholder="min" value={this.state.selectedComponent ?
                                                    this.state.selectedComponent.min : undefined} />
                                        </div>
                                    </div>
                                    : ''}
                            </div>

                            <div>
                                <CheckBox id="hasUnits" text="Has Units" className="checkbox-label"
                                    value={this.state.selectedComponent ? this.state.selectedComponent.hasUnits : false} />
                            </div>
                            <br />

                            {this.state.selectedComponent && this.state.selectedComponent.hasUnits ?
                                <div>
                                    <div className="lq-sub-title">Units of Measure (UOM)</div>
                                    <DataGrid
                                        height="30em"
                                        dataSource={this.state.selectedComponent && this.state.selectedComponent.uoms ?
                                            this.state.selectedComponent.uoms : []}
                                        showBorders={true}>

                                        <LoadPanel enabled={true} />
                                        <Selection mode={'single'} />

                                        <Column dataField={'uomName'} caption={'Name'} width={'25%'} />
                                        <Column dataField={'uomDescription'} caption={'Description'} width={'35%'} />
                                        <Column dataField={'option'} width={'20%'} />
                                        <Column dataField={'defaultUom'} width={'20%'} />

                                        <HeaderFilter visible={true} />
                                        <FilterRow visible={true} />
                                    </DataGrid>
                                </div> : ''}
                        </div>
                    </div>
                </div>

                <DialogPopup visible={this.state.formHelpDocumentsSearchDialogVisible}
                    onHiding={this.hideFormHelpDocumentsSearchDialog}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title="Form Help Documents"
                    width='80vw'
                    height='80vh'>

                    <HelpDocumentSearch formId={this.state.selectedForm ? this.state.selectedForm.formId : ''}
                        onCancel={this.hideFormHelpDocumentsSearchDialog} />

                </DialogPopup>
            </div>
        );
    }

    formsTableSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            let form = e.selectedRowsData[0] as Form;

            if (form) {
                this.setState({ selectedForm: form });
                this.getFormComponents(form.formId);
            }
        }
    }

    componentsTableSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            let component = e.selectedRowsData[0] as FormComponent;

            if (component) {
                this.setState({ selectedComponent: component });
            }
        }
    }

    async onFormValidating(e: any) {
        if (!this.state.dataLoaded)
            return;

        const newForm = e.newData as Form;

        if (newForm) {
            await this.insertForm(newForm)
                .catch((response: ResponseError) => {
                    XXX.publish(ModalSubscriberTopic, { modalType: ApiResponseErrorModal, responseError: response });
                });
        }
    }

    onFormDeleting(e: any) {

    }

    onFormComponentValidating(e: any) {

    }

    onFormComponentDeleting(e: any) {

    }

    createComponentTypeList() {
        let componentTypes: LookupItem[] = [];

        for (const [propertyKey, propertyValue] of Object.entries(FormComponentType)) {
            if (!Number.isNaN(Number(propertyKey))) {
                continue;
            }

            let enumValue = propertyValue as number;

            if (enumValue)
                componentTypes.push({ id: enumValue, name: propertyKey });
        }

        this.setState({ componentTypes: componentTypes });
    }

    async getForms() {
        await CrudFunctions.getData("metadata/allforms")
            .then(data => {
                this.setState({ forms: data });
            })
            .catch((response: ResponseError) => {
                XXX.publish(ModalSubscriberTopic, { modalType: ApiResponseErrorModal, responseError: response });
            });
    }

    async getFormComponents(formId: string) {
        if (!this.state.dataLoaded)
            return;

        await CrudFunctions.getData(`metadata/componentsbyformid/${formId}`)
            .then(data => {
                this.setState({ components: data });
            })
            .catch((response: ResponseError) => {
                XXX.publish(ModalSubscriberTopic, { modalType: ApiResponseErrorModal, responseError: response });
            });
    }

    async getComponent(componentId: string) {
        if (!this.state.dataLoaded)
            return;

        await CrudFunctions.getData(`metadata/componentsbycomponentid/${componentId}`)
            .then(data => {
                this.setState({ selectedComponents: data });
            })
            .catch((response: ResponseError) => {
                XXX.publish(ModalSubscriberTopic, { modalType: ApiResponseErrorModal, responseError: response });
            });
    }

    async insertForm(form: Form) {
        return CrudFunctions.postData("metadata/form", form)
    }

    async insertFormComponent(component: FormComponent) {
        return CrudFunctions.postData("metadata/formcomponent", component);
    }

    async updateForm(form: Form) {
        return CrudFunctions.putData("metadata/form", form);
    }

    async updateFormComponent(component: FormComponent) {
        return CrudFunctions.putData("metadata/formcomponent", component);
    }

    async deleteForm(formId: string) {
        return CrudFunctions.deleteData(`metadata/form/${formId}`);
    }

    async deleteFormComponent(componentId: string) {
        return CrudFunctions.deleteData(`metadata/formcomponent/${componentId}`);
    }

    //render
    formsToolbarTitleTemplateRender(e: any) {
        return (
            <div className="pw-datagrid-toolbar-template">
                <div className="pw-datagrid-toobar-title">Forms</div>
            </div>
        );
    }

    formComponentsToolbarTitleTemplateRender(e: any) {
        return (
            <div className="pw-datagrid-toolbar-template">
                <div className="pw-datagrid-toobar-title">Form Components</div>
            </div>
        );
    }

    // show/hide

    showFormHelpDocumentsSearchDialog() {
        this.setState({ formHelpDocumentsSearchDialogVisible: true });
    }

    hideFormHelpDocumentsSearchDialog() {
        this.setState({ formHelpDocumentsSearchDialogVisible: false });
    }

    componentDidMount() {
        this.getAllData();
    }

    async getAllData() {
        await Promise.all([
            await this.getForms()
        ])
            .then(() => {
                this.setState({ dataLoaded: true }, () => {
                    this.createComponentTypeList();
                });
            });
    }
}
*/

